import charIndexFu from "../assets/images/charactor/index/char_index_image_fu.png";
import charIndexSu from "../assets/images/charactor/index/char_index_image_su.png";
import charIndexLu from "../assets/images/charactor/index/char_index_image_lu.png";
import charIndexPei from "../assets/images/charactor/index/char_index_image_pei.png";
import charIndexFu2x from "../assets/images/charactor/index/char_index_image_fu@2x.png";
import charIndexSu2x from "../assets/images/charactor/index/char_index_image_su@2x.png";
import charIndexLu2x from "../assets/images/charactor/index/char_index_image_lu@2x.png";
import charIndexPei2x from "../assets/images/charactor/index/char_index_image_pei@2x.png";
import charIndexDecoFu from "../assets/images/charactor/index/char_index_deco_fu.png";
import charIndexDecoSu from "../assets/images/charactor/index/char_index_deco_su.png";
import charIndexDecoLu from "../assets/images/charactor/index/char_index_deco_lu.png";
import charIndexDecoPei from "../assets/images/charactor/index/char_index_deco_pei.png";
import charIndexDecoFu2x from "../assets/images/charactor/index/char_index_deco_fu@2x.png";
import charIndexDecoSu2x from "../assets/images/charactor/index/char_index_deco_su@2x.png";
import charIndexDecoLu2x from "../assets/images/charactor/index/char_index_deco_lu@2x.png";
import charIndexDecoPei2x from "../assets/images/charactor/index/char_index_deco_pei@2x.png";
import charIndexNameFu from "../assets/images/charactor/index/char_index_name_fu.png";
import charIndexNameSu from "../assets/images/charactor/index/char_index_name_su.png";
import charIndexNameLu from "../assets/images/charactor/index/char_index_name_lu.png";
import charIndexNamePei from "../assets/images/charactor/index/char_index_name_pei.png";
import charIndexNameFu2x from "../assets/images/charactor/index/char_index_name_fu@2x.png";
import charIndexNameSu2x from "../assets/images/charactor/index/char_index_name_su@2x.png";
import charIndexNameLu2x from "../assets/images/charactor/index/char_index_name_lu@2x.png";
import charIndexNamePei2x from "../assets/images/charactor/index/char_index_name_pei@2x.png";
import charDetailWideFu from "../assets/images/charactor/detail/char_detail_image_fu_1.png";
import charDetailWideFu2x from "../assets/images/charactor/detail/char_detail_image_fu_1@2x.png";
import charDetailWideSu from "../assets/images/charactor/detail/char_detail_image_su_1.png";
import charDetailWideLu from "../assets/images/charactor/detail/char_detail_image_lu_1.png";
import charDetailWidePei from "../assets/images/charactor/detail/char_detail_image_pei_1.png";
import charDetailWidePei2x from "../assets/images/charactor/detail/char_detail_image_pei_1@2x.png";
import charDetailFu from "../assets/images/charactor/detail/char_detail_image_fu_2.png";
import charDetailFu2x from "../assets/images/charactor/detail/char_detail_image_fu_2@2x.png";
import charDetailSu from "../assets/images/charactor/detail/char_detail_image_su_2.jpg";
import charDetailSu2x from "../assets/images/charactor/detail/char_detail_image_su_2@2x.jpg";
import charDetailLu from "../assets/images/charactor/detail/char_detail_image_lu_2.png";
import charDetailLu2x from "../assets/images/charactor/detail/char_detail_image_lu_2@2x.png";
import charDetailPei from "../assets/images/charactor/detail/char_detail_image_pei_2.png";
import charDetailPei2x from "../assets/images/charactor/detail/char_detail_image_pei_2@2x.png";
import charDetailDecoFu from "../assets/images/charactor/detail/char_index_deco_fu.png";
import charDetailDecoSu from "../assets/images/charactor/detail/char_index_deco_su.png";
import charDetailDecoLu from "../assets/images/charactor/detail/char_index_deco_lu.png";
import charDetailDecoPei from "../assets/images/charactor/detail/char_detail_deco_pei.png";
import charDetailDecoPei2x from "../assets/images/charactor/detail/char_detail_deco_pei@2x.png";
import fuVoice from "../assets/audio/fu.mp3";
import suVoice from "../assets/audio/su.mp3";
import luVoice from "../assets/audio/lu.mp3";
import peiVoice from "../assets/audio/pei.mp3";

export const roleData = [
    {
        slug: "fu",
        name: "傅远",
        englishName: "FU YUAN",
        faction: "失序枷锁 / STAR LINEAR",
        personImg: charDetailFu,
        thumbnail: charIndexFu,
        indexImg: charIndexFu,
        indexImg2x: charIndexFu2x,
        indexTransformOrigin: "48% 24%",
        indexDeco: charIndexDecoFu,
        indexDeco2x: charIndexDecoFu2x,
        indexName: charIndexNameFu,
        indexName2x: charIndexNameFu2x,
        detailWideImg: charDetailWideFu,
        detailWideImg2x: charDetailWideFu2x,
        detailPersonImg: charDetailFu,
        detailPersonImg2x: charDetailFu2x,
        detailNameDeco: charDetailDecoFu,
        detailInfoTexts: [
            "傅远",
            "我会一直在你身边。"
        ],
        cardLines: [
             "我会一直在你身边。"
        ],
        desc: "沉默而危险的同行者，习惯把情绪藏进利刃般的目光里。他从不轻易许诺，却会在关键时刻站到你身前。",
        visual: {left: "55%", bottom: "0.42rem", height: "min(64vh, 5.46rem)", scale: "1"},
        voices: [
            {lang: "中", actor: "待公开", audioUrl: fuVoice}
        ]
    },
    {
        slug: "su",
        name: "苏时悠",
        englishName: "SU SHIYOU",
        faction: "失序枷锁 / STAR LINEAR",
        personImg: charDetailSu,
        thumbnail: charIndexSu,
        indexImg: charIndexSu,
        indexImg2x: charIndexSu2x,
        indexTransformOrigin: "52% 24%",
        indexDeco: charIndexDecoSu,
        indexDeco2x: charIndexDecoSu2x,
        indexName: charIndexNameSu,
        indexName2x: charIndexNameSu2x,
        detailWideImg: charDetailWideSu,
        detailPersonImg: charDetailSu,
        detailPersonImg2x: charDetailSu2x,
        detailNameDeco: charDetailDecoSu,
        detailInfoTexts: [
            "苏时悠",
            "相信我。在你面前，我绝无虚假。"
        ],
        cardLines: [
             "相信我。",
             "在你面前，我绝无虚假。"
        ],
        desc: "带着漫不经心笑意的行动派，擅长用轻松语气化解危险。他看似随性，却总能精准看穿局势。",
        visual: {left: "55%", bottom: "0.42rem", height: "min(64vh, 5.46rem)", scale: "1"},
        voices: [
            {lang: "中", actor: "待公开", audioUrl: suVoice}
        ]
    },
    {
        slug: "lu",
        name: "陆择",
        englishName: "LU ZE",
        faction: "失序枷锁 / STAR LINEAR",
        personImg: charDetailLu,
        thumbnail: charIndexLu,
        indexImg: charIndexLu,
        indexImg2x: charIndexLu2x,
        indexTransformOrigin: "52% 24%",
        indexDeco: charIndexDecoLu,
        indexDeco2x: charIndexDecoLu2x,
        indexName: charIndexNameLu,
        indexName2x: charIndexNameLu2x,
        detailWideImg: charDetailWideLu,
        detailPersonImg: charDetailLu,
        detailPersonImg2x: charDetailLu2x,
        detailNameDeco: charDetailDecoLu,
        detailInfoTexts: [
            "陆择",
            "要怎样做……才不会失去你？"
        ],
        cardLines: [
            "要怎样做……",
            "才不会失去你？"
        ],
        desc: "锋芒外露的掌控者，习惯以冷静和压迫感处理所有失控局面。只有在你面前，他才会短暂卸下伪装。",
        visual: {left: "55%", bottom: "0.42rem", height: "min(64vh, 5.46rem)", scale: "1"},
        voices: [
            {lang: "中", actor: "待公开", audioUrl: luVoice}
        ]
    },
    {
        slug: "pei",
        name: "裴予希",
        englishName: "PEI YUXI",
        faction: "失序枷锁 / STAR LINEAR",
        personImg: charDetailPei,
        thumbnail: charIndexPei,
        indexImg: charIndexPei,
        indexImg2x: charIndexPei2x,
        indexTransformOrigin: "48% 26%",
        indexDeco: charIndexDecoPei,
        indexDeco2x: charIndexDecoPei2x,
        indexName: charIndexNamePei,
        indexName2x: charIndexNamePei2x,
        detailWideImg: charDetailWidePei,
        detailWideImg2x: charDetailWidePei2x,
        detailPersonImg: charDetailPei,
        detailPersonImg2x: charDetailPei2x,
        detailNameDeco: charDetailDecoPei,
        detailNameDeco2x: charDetailDecoPei2x,
        detailInfoTexts: [
            "裴予希",
            ""
        ],
        cardLines: [
            "只要能再一次……",
            "见到你。"              
        ],
        desc: "冷淡克制的守序者，行事精准、不留破绽。他习惯保持距离，却会默默记住与你有关的一切。",
        visual: {left: "55%", bottom: "0.42rem", height: "min(64vh, 5.46rem)", scale: "1"},
        voices: [
            {lang: "中", actor: "待公开", audioUrl: peiVoice}
        ]
    }
];
